import { Directive, ElementRef, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[mcraiCarouselItem]'
})
export class ItemDirective {
  readonly DEFAULT_ITEM_WIDTH = 300;

  private _width: number;
  get width(): number {
    return this._width || this.DEFAULT_ITEM_WIDTH;
  }

  @Input() set mcraiCarouselItem(value: number) {
    this._width = value;
  }

  get template(): TemplateRef<any> {
    return this._templateRef;
  }

  get host(): HTMLElement {
    return this._elRef.nativeElement;
  }

  constructor(
    private _templateRef: TemplateRef<any>,
    private _elRef: ElementRef
  ) { }

}
